import { createContext } from "react"

const Firebase = createContext({})

export default Firebase
